import { ChangeDetectionStrategy, Component, OnInit, signal, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SetupTwoFactorAuthChooserComponent } from 'projects/components/setup-two-factor-auth-chooser/setup-two-factor-auth-chooser.component';
import { AuthService } from 'projects/login/src/app/services/auth/auth.service';
import { TokenService } from 'projects/login/src/app/services/auth/token.service';
import { RedirectService } from '../../../services/redirect/redirect.service';

@Component({
  selector: 'pay-login-act-setup-two-factor-auth',
  imports: [SetupTwoFactorAuthChooserComponent, TranslateModule],
  templateUrl: './act-setup-two-factor-auth.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActSetupTwoFactorAuthComponent implements OnInit {
  private readonly _redirectService = inject(RedirectService);
  private readonly auth = inject(AuthService);
  private readonly token = inject(TokenService);

  protected mfaToken = signal<undefined | string>(undefined);

  ngOnInit(): void {
    if (!TokenService.password || !TokenService.username) {
      this._redirectService.goToInvalidSession();
      return;
    }

    this.auth
      .token(TokenService.sessionId!, {
        password: TokenService.password,
        username: TokenService.username,
        rememberEmail: false,
      })
      .subscribe({
        next: (r) => {
          if (this.auth.isMFAChallengedResponse(r)) {
            this.mfaToken.set(r.authenticationToken.token);
            this.token.accessToken = r.authenticationToken.token;
          }
        },
      });
    this._redirectService.setRedirectUrl('/activation/finished', true);
  }
}
